// @ts-ignore
import { spring } from 'vue3-spring';
export const useScaleEffect = (
  scaleIni,
  center = false,
  damping: number = 8,
  stiffness: number = 170,
  mass: number = 0.96
) => {
  const factor = ref(1000);
  const scale = ref(scaleIni);
  const scaleEffect = ref<number>(toValue(scale) * toValue(factor));

  const scaleSpring = spring(scaleEffect, {
    from: toValue(scaleEffect),
    damping,
    stiffness,
    mass,
  });

  const style = computed(() => {
    if (center) {
      return {
        transform: `
          translate(-50%, -50%)
          scale(${scaleSpring.value / factor.value})`,
      };
    }
    return {
      transform: `scale(${scaleSpring.value / factor.value})`,
    };
  });

  watch(
    () => toValue(scale) * toValue(factor),
    (v) => {
      scaleEffect.value = v;
    }
  );

  return { style, scale };
};
